import * as Yup from 'yup';

import { phoneRegex } from '../../utils/utils';

export const DispatcherUserSchema = Yup.object().shape({
  userName: Yup.string().min(1).required('Name is required'),
  phoneNumber: Yup.string()
    .matches(phoneRegex, 'Invalid Nigerian phone number')
    .required('Phone number is required'),
  email: Yup.string().min(1).required('Email is required'),
  firstName: Yup.string().min(1).required('Name is required'),
  lastName: Yup.string().min(1).required('Name is required'),
  warehouseId: Yup.string().min(1).required('Warehouse is required'),
  vehicleType: Yup.string().min(1).required('Vehicle Type is required'),
});

export type DispatcherUserDataType = Yup.InferType<typeof DispatcherUserSchema>;

type InitialValues = {
  userName: string;
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  warehouseId: string;
  vehicleType: string;
};

export const DispatcherUserInitialValues: InitialValues = {
  userName: '',
  phoneNumber: '',
  email: '',
  firstName: '',
  lastName: '',
  warehouseId: '',
  vehicleType: '',
};

export interface IDispatcherUserResponse {}

export interface IDispatcherUserRequest {
  userName: string;
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  warehouseId: string;
  role: string;
  vehicleType: string;
}
